// fix-colorpicker.directive.ts
import { Directive, AfterViewInit } from '@angular/core';
import { ColorPicker } from 'primeng/colorpicker';

@Directive({
    selector: 'p-colorpicker[fixXScroll]'  // apply with <p-colorPicker fixXScroll>
})
export class FixColorpickerXScrollDirective implements AfterViewInit {
    constructor(private cp: ColorPicker) { }

    ngAfterViewInit() {
        
        // ------------------------------------------------------------METHOD 1
        // keep the original as a fallback if you like
        const originalPickColor = this.cp.pickColor.bind(this.cp);
        // override
        this.cp.pickColor = (event: MouseEvent | TouchEvent, position?: any) => {
              // unify to client coords
              const clientX = position?.clientX ?? (event as MouseEvent).clientX;
              const clientY = position?.clientY ?? (event as MouseEvent).clientY;
              const rect    = this.cp.colorSelectorViewChild!.nativeElement.getBoundingClientRect();

              // compute local X/Y inside the 150×150 picker
              const localX = Math.max(0, Math.min(rect.width,  clientX - rect.left));
              const localY = Math.max(0, Math.min(rect.height, clientY - rect.top));

              // map to 0–100%
              const sat = Math.floor((100 * localX) / rect.width);
              const bri = Math.floor((100 * (rect.height - localY)) / rect.height);

              // update the component’s state
              this.cp.value = this.cp.validateHSB({ h: this.cp.value.h, s: sat, b: bri });
              this.cp.updateUI();
              this.cp.updateModel();
              this.cp.onChange.emit({ originalEvent: event, value: this.cp.getValueToUpdate() });
        };

        // //------------------------------------------------------------METHOD 2
        // // keep the original as a fallback if you like
        // const originalPickColor = this.cp.pickColor.bind(this.cp);
        // // override
        // this.cp.pickColor = (event: MouseEvent | TouchEvent, position?: any) => {
        //     let pageX = position ? position.pageX : (event as MouseEvent).pageX;
        //     let pageY = position ? position.pageY : (event as MouseEvent).pageY;
        //     let rect = this.cp.colorSelectorViewChild?.nativeElement.getBoundingClientRect();
        //     let top = rect.top + ((this.cp as any).document.defaultView.pageYOffset || (this.cp as any).document.documentElement.scrollTop || (this.cp as any).document.body.scrollTop || 0);
        //     let left = rect.left + ((this.cp as any).document.defaultView.pageXOffset || (this.cp as any).document.documentElement.scrollLeft || (this.cp as any).document.body.scrollLeft || 0);
        //     let saturation = Math.floor((100 * Math.max(0, Math.min(150, pageX - left))) / 150);
        //     let brightness = Math.floor((100 * (150 - Math.max(0, Math.min(150, pageY - top)))) / 150);
        //     this.cp.value = this.cp.validateHSB({
        //         h: this.cp.value.h,
        //         s: saturation,
        //         b: brightness
        //     });

        //     this.cp.updateUI();
        //     this.cp.updateModel();
        //     this.cp.onChange.emit({ originalEvent: event, value: this.cp.getValueToUpdate() });
        // };

        // //------------------------------------------------------------METHOD 3 - WORKS - DERIVED FROM METHOD 2
        // // keep a reference to the original
        // const original = this.cp.pickColor.bind(this.cp);

        // // grab the document it’s using internally
        // const doc = (this.cp as any).document as Document;

        // // override just that one method
        // this.cp.pickColor = (event: MouseEvent | TouchEvent, position?: any) => {
        //     // exactly the same as the built‑in, except we patch `left` below
        //     const pageX = position?.pageX ?? (event as MouseEvent).pageX;
        //     const pageY = position?.pageY ?? (event as MouseEvent).pageY;
        //     const rect = this.cp.colorSelectorViewChild!.nativeElement.getBoundingClientRect();

        //     // vertical is already correct…
        //     const top = rect.top +
        //         (doc.defaultView!.pageYOffset ||
        //             doc.documentElement.scrollTop ||
        //             doc.body.scrollTop ||
        //             0);

        //     // **here’s the only change**: use pageXOffset (and fallbacks) instead of body.scrollLeft alone
        //     const scrollX = doc.defaultView!.pageXOffset ||
        //         doc.documentElement.scrollLeft ||
        //         doc.body.scrollLeft ||
        //         0;
        //     const left = rect.left + scrollX;
        //     console.log(scrollX);

        //     // compute exactly as PrimeNG does
        //     const saturation = Math.floor(
        //         (100 * Math.max(0, Math.min(150, pageX - left))) / 150
        //     );
        //     const brightness = Math.floor(
        //         (100 * (150 - Math.max(0, Math.min(150, pageY - top)))) / 150
        //     );

        //     // now delegate to the component’s own HSB logic
        //     this.cp.value = this.cp.validateHSB({
        //         h: this.cp.value.h,
        //         s: saturation,
        //         b: brightness
        //     });
        //     this.cp.updateUI();
        //     this.cp.updateModel();
        //     this.cp.onChange.emit({
        //         originalEvent: event,
        //         value: this.cp.getValueToUpdate()
        //     });
        // };
    }
}
